import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AppShell } from '@/components/layout/AppShell';
import { PageContainer } from '@/components/layout/PageContainer';
import { TopBar } from '@/components/layout/TopBar';
import { Input } from '@/components/ui/Input';
import { Card } from '@/components/ui/Card';
import { Button } from '@/components/ui/Button';
import { IcSearch } from '@/components/ui/icons';
import { paths } from '@/routes/paths';

// Public company search is NOT exposed by the backend (Addendum-01 path:
// employer onboarding goes via /companies/verify magic-link token, not
// a public catalogue). Until a public endpoint ships, this page renders
// a graceful "we don't have a directory yet — contact support / create
// a company" prompt instead of fake sample data.
export function BusinessSearchPage(): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [q, setQ] = useState('');

  return (
    <AppShell>
      <PageContainer paddingX="md">
        <TopBar back title={t('business.search')} />
        <Input
          startAdornment={<IcSearch />}
          placeholder={t('business.search_placeholder')}
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
        <Card variant="light" padding="md">
          <div style={{ fontWeight: 600, marginBottom: 6 }}>
            {t('business.search_unavailable_title')}
          </div>
          <p style={{ margin: 0, marginBottom: 12, color: 'var(--color-text-on-dark-muted)' }}>
            {t('business.search_unavailable_body')}
          </p>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <Button size="md" variant="inverted" onClick={() => navigate(paths.businessCreate)}>
              {t('business.create')}
            </Button>
            <Button size="md" variant="ghost" onClick={() => navigate(paths.support)}>
              {t('business.contact_support')}
            </Button>
          </div>
        </Card>
      </PageContainer>
    </AppShell>
  );
}
